import React from 'react';
import styled from 'styled-components';
import {
  SYS_BREAKPOINT_LG,
  SYS_PAGE_MARGIN,
  SYS_SPACE_RELATIVE_2_XL,
  SYS_SPACE_RELATIVE_3_XL,
  SYS_SPACE_RELATIVE_LG,
} from '@oneaudi/unified-web-common';
import { Layout, Skeleton } from '@oneaudi/unified-web-components';
import { TileSkeleton } from './TileSkeleton';
import { TilesContainer } from '../Tiles.styles';

const SkeletonBody = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding-right: ${SYS_PAGE_MARGIN};
  margin-left: ${SYS_SPACE_RELATIVE_3_XL};
`;
export const AutoSpaceRowSkeletonContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
const MoreVehiclesButtonContainer = styled.div`
  display: flex;
  justify-content: center;
`;
const MobileContainer = styled.div`
  display: flex;
  flex-direction: column;
  @media (min-width: ${SYS_BREAKPOINT_LG}) {
    display: none;
  }
`;
const DesktopContainer = styled.div`
  display: none;
  @media (min-width: ${SYS_BREAKPOINT_LG}) {
    display: block;
  }
`;

interface Props {}

export const TilesSkeleton: React.FC<Props> = () => {
  return (
    <SkeletonBody>
      {/* Headline */}
      <MobileContainer>
        <Skeleton
          variant="rectangular"
          width="150px"
          height="24px"
          margin={['6px', 0, SYS_SPACE_RELATIVE_LG, 0]}
        />
        {/* Results Bar */}
        <AutoSpaceRowSkeletonContainer>
          <Skeleton variant="rectangular" width="50px" height="24px" />
          <Skeleton variant="rectangular" width="150px" height="56px" />
        </AutoSpaceRowSkeletonContainer>
      </MobileContainer>
      <DesktopContainer>
        {/* Results Bar */}
        <AutoSpaceRowSkeletonContainer>
          <Layout direction="row">
            <Skeleton variant="rectangular" width="150px" height="24px" />
            <Skeleton variant="rectangular" width="50px" height="24px" margin={[0, 0, 0, '12px']} />
          </Layout>
          <Skeleton variant="rectangular" width="150px" height="56px" />
        </AutoSpaceRowSkeletonContainer>
      </DesktopContainer>
      <TilesContainer>
        {/* Render 12 Tiles for every Viewport */}
        <TileSkeleton />
        <TileSkeleton />
        <TileSkeleton />
        <TileSkeleton />
        <TileSkeleton />
        <TileSkeleton />
        <TileSkeleton />
        <TileSkeleton />
        <TileSkeleton />
        <TileSkeleton />
        <TileSkeleton />
        <TileSkeleton />
      </TilesContainer>
      {/* More Vehicles Button */}
      <MoreVehiclesButtonContainer>
        <Skeleton
          variant="rectangular"
          width="319px"
          height="48px"
          margin={[SYS_SPACE_RELATIVE_2_XL, 0, 0, 0]}
        />
      </MoreVehiclesButtonContainer>
    </SkeletonBody>
  );
};
